export const leadAssignmentEnabled =
  process.env.REACT_APP_FEATURE_LEAD_ASSIGNMENT !== 'false';
